import { FC } from "react";
import { DropsStaticAlert } from "shared/components/Spor";

export const GlobalEventTempFixText: FC = () => (
  <DropsStaticAlert variant="important" width="100%" fontSize="16px" m={2}>
    Muligheten til å opprette globale meldinger fremover i tid er midlertidlig
    skrudd av mens vi venter på en fiks hos vy.no
  </DropsStaticAlert>
);
